// Takes a subtree out of reach while something covers it: no focus, no
// clicks, and hidden from assistive technology (the `inert` attribute).
// Set on the element rather than as a prop, which React 18 does not know.

import { useEffect, useRef } from "react";

export const useInert = <T extends HTMLElement>(inert: boolean) => {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (ref.current) ref.current.inert = inert;
  }, [inert]);
  return ref;
};
